/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Steps_Scene_BodyInputs */

const en_road_dude_steps_scene_body = /** @type {(inputs: Road_Dude_Steps_Scene_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep the truck parked and the camera at window height. Give the driver one small gesture and time to deliver the line.`)
};

const zh_road_dude_steps_scene_body = /** @type {(inputs: Road_Dude_Steps_Scene_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`让车停着，镜头与车窗齐平。给司机安排一个小动作，并留出说完台词的时间。`)
};

/**
* | output |
* | --- |
* | "Keep the truck parked and the camera at window height. Give the driver one small gesture and time to deliver the line." |
*
* @param {Road_Dude_Steps_Scene_BodyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_steps_scene_body = /** @type {((inputs?: Road_Dude_Steps_Scene_BodyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Steps_Scene_BodyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_steps_scene_body(inputs)
	return zh_road_dude_steps_scene_body(inputs)
});
export { road_dude_steps_scene_body as "road_dude.steps.scene.body" }